import {each} from 'lodash';

class agreementsController {
	constructor($bookings,
	            $auth,
	            $translates,
	            $rootScope,
	            $uibModal,
	            $scope) {

		'ngInject';

		this.$bookings = $bookings;
		this.$auth = $auth;
		this.target = 'working';
		this.$rootScope = $rootScope;
		this.$scope = $scope;

		this.agreements = this.resolve.items.agreements;

	}

	$onClose($event) {
		$event.preventDefault();
		this.close({$value: 'cancel'});
	}

	$onSubmit(formAgreements, $event){
		console.log(this.agreements);
		const user = this.$auth.getUser();
		user.agreements = JSON.stringify(this.agreements);
		user.agreements_accepted = true;
		console.log(user);
		this.$auth.saveMe(user)
			.then(() => this.close())
			.finally(() => formAgreements.$submitted = false );
  }

  selectAll($event) {
		if ($event.target.checked) {
			Object.keys(this.agreements).forEach(key => this.agreements[key] = true);
		} else {
			Object.keys(this.agreements).forEach(key => this.agreements[key] = false);
		}
	}

	get selectedAll() {
		let allChecked = true;
		Object.keys(this.agreements).forEach(key => allChecked = allChecked && this.agreements[key]);
		return allChecked;
	}



}


export default agreementsController;


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/agreements/agreements.controller.js
 **/